module.exports = __webpack_public_path__ + "img/work5.3b9cdf6a.svg";